import DataTable from '../../components/DataTable';
import { formatDate } from '../../utils/formatters';

const userIdentifier = (user) => user.userId || user.anonymousId || user.deviceId || user.id || '-';

const AppUsersPage = ({
  users,
  filters,
  setFilters,
  loadUsers,
  onDeleteUser,
  onSaveUserFullName,
  loading,
}) => {
  const columns = [
    {
      key: 'name',
      label: 'שם מלא',
      render: (user) => (
        <form
          className="inline-name-form"
          onSubmit={(event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            onSaveUserFullName(user, String(formData.get('fullName') || ''));
          }}
        >
          <input
            name="fullName"
            defaultValue={user.fullName || user.name || ''}
            maxLength={80}
            placeholder="שם מלא"
          />
          <button type="submit" className="mini" disabled={loading}>
            שמירה
          </button>
        </form>
      ),
    },
    {
      key: 'identifier',
      label: 'מזהה',
      render: (user) => (
        <div>
          <strong>{userIdentifier(user)}</strong>
          <div className="muted table-subtext">
            {user.platform || 'unknown'} · {user.deviceId || '-'}
          </div>
        </div>
      ),
    },
    {
      key: 'reportsCount',
      label: 'כמות דיווחים',
      render: (user) => user.reportsCount || 0,
    },
    {
      key: 'points',
      label: 'נקודות',
      render: (user) => user.points || user.community?.points || 0,
    },
    {
      key: 'lastSeenAt',
      label: 'נראה לאחרונה',
      render: (user) => formatDate(user.lastSeenAt),
    },
    {
      key: 'delete',
      label: 'מחיקה מהמאגר',
      render: (user) => (
        <button
          type="button"
          className="danger mini"
          disabled={loading}
          onClick={(event) => {
            event.stopPropagation();
            onDeleteUser(user);
          }}
        >
          מחיקה
        </button>
      ),
    },
  ];

  return (
    <section className="work-area table-page" dir="rtl">
      <header className="section-header">
        <div>
          <h1>משתמשי האפליקציה</h1>
          <span>{users.total} משתמשים</span>
        </div>
        <div className="filters users-filters">
          <input
            placeholder="חיפוש לפי מזהה, מכשיר או פלטפורמה"
            value={filters.userSearch}
            onChange={(event) =>
              setFilters({
                ...filters,
                userSearch: event.target.value,
              })
            }
          />
          <button onClick={() => loadUsers(1)}>סינון</button>
        </div>
      </header>

      <DataTable
        columns={columns}
        items={users.items}
        rowKey={(user) => user.id}
        page={users.page}
        limit={users.limit}
        total={users.total}
        onPageChange={loadUsers}
        loading={loading}
      />
    </section>
  );
};

export default AppUsersPage;
